import { render, staticRenderFns } from "./Registercust.vue?vue&type=template&id=6127c94e&scoped=true&"
import script from "./Registercust.vue?vue&type=script&lang=js&"
export * from "./Registercust.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6127c94e",
  null
  
)

export default component.exports